import { render, staticRenderFns } from "./SelectorTipoProduto.vue?vue&type=template&id=317d5dae&scoped=true"
import script from "./SelectorTipoProduto.vue?vue&type=script&lang=js"
export * from "./SelectorTipoProduto.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorTipoProduto.vue?vue&type=style&index=2&id=317d5dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317d5dae",
  null
  
)

export default component.exports